'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['INPUT', 'TEXTAREA', 'SELECT'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplayer-utils/lib/keyIgnoredElementNames.js
// module id = 759
// module chunks = 0